/** French unit names for Unit Conversion (ADR 0051 part 3). See the Spanish module for the design note. */
export const conversionTable: Record<string, { small: string; large: string; factor: number }[]> = {
    Metric: [
        { small: "mm", large: "cm", factor: 10 },
        { small: "cm", large: "m", factor: 100 },
        { small: "m", large: "km", factor: 1000 },
        { small: "mm", large: "m", factor: 1000 },
        { small: "mL", large: "L", factor: 1000 },
        { small: "g", large: "kg", factor: 1000 },
    ],
    Customary: [
        { small: "pouces", large: "pieds", factor: 12 },
        { small: "pieds", large: "yards", factor: 3 },
        { small: "pouces", large: "yards", factor: 36 },
        { small: "onces", large: "livres", factor: 16 },
        { small: "tasses", large: "chopines", factor: 2 },
        { small: "chopines", large: "pintes", factor: 2 },
        { small: "pintes", large: "gallons", factor: 4 },
        { small: "tasses", large: "pintes", factor: 4 },
        { small: "chopines", large: "gallons", factor: 8 },
    ],
    Time: [
        { small: "secondes", large: "minutes", factor: 60 },
        { small: "minutes", large: "heures", factor: 60 },
        { small: "heures", large: "jours", factor: 24 },
        { small: "jours", large: "semaines", factor: 7 },
    ],
};
